export const handlePointerover = (event, self, sprite) => {
  self.isOver = true;
  self.texture = sprite.texture;
};

export const handlePointerout = (event, self, sprite) => {
  self.isOver = false;
  self.texture = sprite.texture;
};
